const ko = {
    "2 GB 以上":"2GB 이상",
    "512MB 以上":"512MB 이상",
    "5GB 以上":"5GB 이상",
    "Direct X 9.0 以上":"Direct X 9.0 이상",
    "FB私訊":"FB 비공개 메시지 :",
    "Gefrce 8600GR 以上":"Geforce 8600GR 이상",
    "Radeon 9000;Geforce5200 以上":"Geforce 8600GR 이상",
    "Core2 Duo Dual-core Processor 以上":"Core2 Duo Dual-Kern Prozessor 이상",
    "Pentium 1.4GHz 以上":"Pentium 1.4GHz oder besser",
    "Radeon 9000; Geforce5200 以上":"Radeon 9000;Geforce5200 이상",
    "Windows 7/10相容":"Windows 7/10 호환",
    "記憶卡":"메모리 카드",
    "顯示卡":"그래픽 카드",
    "作業系統":"운영체제",
    "請點擊上方按鈕下載遊戲主程式":"상단의 버튼을 클릭하여 게임클라이언트를 다운로드하세요",
    "执行《Karos Online》系统需求":"카로스 온라인 시스템 최소/권장사양 안내",
    "您的电脑可能需要达到以下配备":"컴퓨터가 다음 사양을 만족해야 합니다",
    "安裝配備":"설치 사양",
    "最低配备":"최소 사양",
    "推荐配备":"권장사양",
    "註冊karos遊戲賬號":"회원 가입",
    "windows遊戲主程式":"윈도우 게임 메인 프로그램",
    "會員資料":"마이 페이지",
    "more":"more",
    "回報記錄":"回報記錄",
    "查看详情":"내역 조회",
    "查看更多":"more",
    "官網首頁": "공식 홈페이지 메인",
    "最新消息": "최신 소식",
    "綜合": "종합",
    "公告": "공지사항",
    "活動": "이벤트",
    "更新": "업데이트",
    "职业定位":"클래스",
    "遊戲資訊": "게임 정보",
    "遊戲地圖": "게임 맵",
    "遊戲指南": "게임 가이드",
    "遊戲视频": "영상 ",
    "社群": "커뮤니티",
    "登出成功":"로그아웃 성공",
    "圖片分享區": "사진 공유 영역",
    "攻略討論區": "공략 게시판",
    "玩家討論區": "자유 게시판",
    "客服中心": "서비스 센터",
    "1:1詢問": "1:1 문의",
    "會員條款": "이용 약관",
    "下載專區": "다운로드",
    "游戲下載": "게임 다운로드",
    "商城": "상점",
    "儲值點數": "저장된 가치 포인트",
    "購買元寶": "캐시 구매",
    "購買記錄": "구매 기록",
    "儲值記錄": "충전 기록",
    "會員註冊": "회원 가입",
    "查詢帳號": "계정 조회",
    "查詢密碼": "비밀번호 찾기",
    "登入": "로그인",
    "登出": "로그아웃",
    "我的資料": "내 정보",
    "密碼更改": "비밀번호 변경",
    "我的點数：": "내 팡캐시 : ",
    "購買P-point後": "P-point 구매 후",
    " 點": "포인트",
    "商城→購買元寶":"상점 → 캐시 구매",
    "玩家必須先儲值點數，方可在 購買元寶 頁面購買RF Online的元寶": "카로스 온라인 다이아를 구매하기 위해서는 먼저 팡캐시를 충전해야 합니다.",
    "上一頁": "이전 페이지",
    "下一頁": "다음 페이지",
    "例行維護時間": "정기점검 시간:",
    "每週四": "매주 화요일 10:00 ~ 12:00",
    "客服服務時間": "고객 서비스 시간:",
    "週一至週五": "월~금 10:00~ 12:30 / 13:30~ 18:30",
    "客服信箱": "고객센터 메일",
    "硬碟容量":"하드디스크용량",
    "視頻": "영상 ",
    "原畫": "원화",
    "發文": "게시",
    "輸入關鍵字": "키워드 입력",
    "搜索": "검색",
    "全文": "전문",
    "主題": "제목",
    "會員帳號": "회원 계정",
    "安裝/執行": "설치 / 실행",
    "儲值/購買": "충전 / 구매",
    "遊戲問題": "게임 문제",
    "消費記錄": "소비 기록",
    "訂單編號": "주문 번호",
    "狀態": "상태",
    "商品": "상품",
    "價格": "가격",
    "登錄日": "로그인 날짜",
    "實名認證": "확인완료",
    "我的禮包": "나의 게임",
    "暱稱：": "닉네임 :",
    "帳號：": "계정 :",
    "帳號": "계정",
    "密碼": "비밀번호",
    "信箱：": "메일 :",
    "手機號碼：": "휴대폰 번호 :",
    "同意接受": "약관 동의",
    "《會員服務條款》": "《회원 서비스 약관》",
    "《個人隱私條款》": "《개인 정보 보호 정책》",
    "同意接受 Panggame 消息及廣告訊息": "Panggame 뉴스 및 광고 메시지 수신에 동의",
    "同意接受在panggame提供的活動抽獎 及遊戲服務同意通知相關sms訊息": "Panggame에서 제공하는 이벤트 추첨 및 게임 서비스 수신에 동의하고 관련 SMS 메시지 알림에 동의",
    "輸入新密碼": "새 비밀번호 입력 :",
    "請確認密碼": "비밀번호를 확인하세요.",
    "姓名": "성명",
    "請輸入身份證號": "주민등록번호를 입력하세요",
    "取消": "취소",
    "確認": "확인",
    "記住登入資訊": "로그인 정보 기억",
    "手機找回": "휴대폰으로 찾기",
    "信箱找回": "메일 찾기",
    "手機": "휴대폰",
    "請輸入信箱": "메일을 입력하세요",
    "信箱格式有誤": "잘못된 메일 형식",
    "請輸入姓名": "이름을 입력하세요",
    "請輸入密碼": "비밀번호를 입력하세요",
    "請輸入手機號": "휴대폰 번호를 입력하세요",
    "手機號碼不正確，請重新輸入": "번호가 올바르지 않습니다. 다시 입력하세요.",
    "請輸入手機號碼": "휴대폰 번호를 입력하세요",
    "請輸入文章主題": "게시글 제목을 입력하세요",
    "請輸入新的信箱地址": "새 메일주소를 입력하세요",
    "請輸入正確帳號": "정확한 계정을 입력해 주세요",
    "請輸入自訂帳號": "자체정의 계정을 입력해 주세요",
    "請輸入角色": "캐릭터명을 입력하세요",
    "請輸入帳號": "계정을 입력해 주세요",
    "請輸入郵箱": "이메일을 입력하세요",
    "請輸入驗證碼": "인증 코드를 입력하세요",
    "驗證碼為 6 位數字": "인증 코드는 6 자리입니다.",
    "獲取驗證碼": "인증 코드 받기",
    "驗證碼": "인증 코드",
    "修改": "수정",
    "信箱註冊": "메일 회원가입",
    "手機註冊": "휴대폰 회원가입",
    "歡迎加入panggame!": "panggame에 가입하신 것을 환영합니다!",
    "爲使用遊戲，請按照以下的格式進行註冊流程。": "게임을 이용하기 위해서는 회원가입 절차를 따라 가입을 진행해주시기 바랍니다.",
    "完成註冊，即刻獲得上市祝福禮包！": "회원가입을 완료하고 즉시 오픈 축하 패키지를 받으십시오!",
    "購買": "구입",
    "點數是什麼？": "팡캐시는 무엇입니까?",
    "點數購買": "Karos 캐시 구매",
    "儲值點數時，請先確認金額後再購買": "포인트 충전 시 먼저 구매 금액을 확인 해주세요.",
    "購買成功": "구매 성공",
    "點数不足": "팡캐시 부족",
    "消耗點數：": "캐시소비 :",
    "當前點數：": "현재 팡캐시 :",
    "購買價格：": "구매 가격 :",
    "道具資訊：": "아이템 정보 :",
    "持有點數：": "보유 캐시 :",
    "扣除後點數：": "공제 후 캐시 :",
    "您正在購買元寶": "캐시 구매중 입니다.",
    "取消購買": "구매 취소",
    "確認購買": "구매 확인",
    "儲值點數：": "저장된 가치 포인트 :",
    "儲值後點數：": "충전 후 포인트 :",
    "暱稱僅有一次修改機會": "닉네임은 한 번만 수정할 수 있습니다.",
    "輸入新暱稱": "새 닉네임 입력",
    "舊信箱地址：": "이전 메일 주소 :",
    "新信箱地址：": "새 메일주소 :",
    "舊手機號碼：": "이전 휴대폰번호 :",
    "新手機號碼：": "새 휴대폰 번호 :",
    "手機：": "휴대폰 번호 :",
    "已處理":"처리완료",
    "待處理":"보류중",
    "發送成功": "발송 성공",
    "上載失敗": "업로드 실패",
    "兩次輸入的密碼並不相符，請重新輸入": "두 번 입력 한 비밀번호가 일치하지 않습니다. 다시 입력하십시오.",
    "請勾選同意接受條款": "약관에 동의하려면 선택하십시오",
    "註冊成功": "가입 성공",
    "分類": "분류",
    "問題": "문제",
    "聊天": "채팅",
    "建議": "제안",
    "留言": "메시지",
    "上留言": "메시지를 남겨주세요",
    "回復": "댓글",
    "请输入关键字": "키워드를 입력하세요",
    "發佈辱罵,相同文章重覆發文,誹謗,謠言等違反營運政策的貼文時，可能會受到限制發文，若有違法情事發生，自行負擔法律相關責任. 最長100個字元": "욕설, 동일 게시글 반복 작성, 비방, 루머 등 운영 정책에 위배되는 게시물은 제한 될 수 있으며, 위반시 법적 책임은 귀하에게 있습니다. {길이} / 최대 100 자",
    "使用點數": "포인트 사용",
    "當前點數": "현재 팡캐시",
    "商品名": "상품명",
    "確認密碼": "비밀번호",
    "您的信箱地址": "귀하의 메일주소",
    "請輸入賬號": "계정을 입력하세요",
    "密碼長度最少為 8 字元": "비밀번호는 8 자 이상이어야 합니다.",
    "密碼不能有特殊字元": "비밀번호는 특수문자를 포함할 수 없습니다.",
    "自訂賬號需為英文字母和數字的組合，且第一個字元必須為英文，英文及數字必須為半形": "닉네임은 영문자와 숫자의 조합이어야하며 첫 번째 문자는 영문이어야하며 영문과 숫자는 반자 여야합니다.",
    "自訂賬號長度最多為 32 字元": "닉네임의 길이는 최대 32 자입니다.",
    "修改成功": "수정 성공",
    "未查找到該賬號": "계정을 찾을 수 없습니다",
    "暫無數據": "데이터 없음",
    "賬號第一位必須為英文字母，最多 32 個字元": "계정의 첫 번째 문자는 영문자여야 합니다(최대 32 자)",
    "請輸入自訂賬號": "닉네임을 입력하세요",
    "立即註冊": "즉시 회원가입",
    "極速下載": "빠른 다운로드",
    "新手指南": "초보자 가이드",
    "裝備技能": "裝備技能",
    "進階攻略": "진급 공략",
    "其他": "기타",
    "角色介绍": "캐릭터 소개",
    "刪除": "삭제",
    "刪除文章": "게시글 삭제",
    "刪除留言": "댓글 삭제",
    "確定要刪除嗎？": "계속 삭제하시겠습니까?",
    "OnGate 账号:": "OnGate 账号:",
    "二次登录密码:": "二次登录密码:",
    "真实姓名:": "실명:",
    "出生日期:": "출생시간:",
    "请输入OnGate 账号": "请输入OnGate 账号",
    "请输入游戏账号二次登录密码": "请输入游戏账号二次登录密码",
    "请输入真实姓名": "请输入真实姓名",
    "请输入出生日期": "请输入出生日期",
    "请输入密码": "비밀번호를 입력하세요",
    "請選擇分類": "請選擇分類",
    "請輸入": "입력하세요",
    "請輸入主題": "請輸入主題",
    "请输入手机号码接收验证码信息": "请输入手机号码接收验证码信息",
    "请输入邮箱接收验证码信息": "请输入邮箱接收验证码信息",
    "实名认证信息不对": "실명인증 입력한 정보 오류",
    "確認新密碼不一致": "비밀번호 확인",
  }
  
  module.exports = ko
  